module.exports = __webpack_public_path__ + "img/ic_chevrons_down_outline.f0740fcf.svg";